export default [
  {
    path: '/vantCalendared',
    name: 'vantcalendared',
    component: (r) => require(['@/child/app/appCalendard/views/vantCalendard.vue'], r)
    // meta: {
    //   requireAuth: true
    // }
  }
]
